import styled from 'styled-components'
import Collapsible from 'react-collapsible'

export const CollapsibleStyle = styled(Collapsible)``
